import { ThemeOptions } from '@mui/material'
import { deepmerge } from '@mui/utils'

import { Settings } from '@core/context/settingsContext'

import UserThemeOptions from '~/layouts/UserThemeOptions'
import { type PaletteThemeId, paletteModeFor } from '~/theme/themePreference'

import breakpoints from './breakpoints'
import overrides from './overrides'
import shadows from './shadows'

const themeOptions = (settings: Settings, themeId: PaletteThemeId): ThemeOptions => {
  const { direction, accentColor } = settings
  const mode = paletteModeFor(themeId)
  const userThemeConfig: ThemeOptions = Object.assign({}, UserThemeOptions(themeId, accentColor))

  return deepmerge(
    {
      breakpoints: breakpoints(),
      direction,
      components: overrides(),
      spacing: (factor: number) => `${0.25 * factor}rem`,
      shape: {
        borderRadius: 10
      },
      mixins: {
        toolbar: {
          minHeight: 56
        }
      },
      shadows: shadows(mode)
    },
    userThemeConfig
  )
}

export default themeOptions
